import { CompositeDecorator, ContentBlock, ContentState, convertFromRaw, EditorState, genKey } from 'draft-js';
// @ts-expect-error
import { getSelectionText, getSelectedBlocksList } from 'draftjs-utils';
import { partial } from 'ramda';

import { CustomClassDecorator, findCustomClassEntities } from './Decorators';
import { findEmojiEntities, EmojiDecorator } from './Toolbar/Items/Emoji';
import { findLinkEntities, LinkDecorator } from './Toolbar/Items/Link';
import * as t from './Wysiwyg.types';

const getDecorator = (isReadOnly: boolean) => {
  const isPdf = localStorage.getItem('pdfPreview');

  return new CompositeDecorator([
    {
      strategy: findLinkEntities,
      component: partial(LinkDecorator, [isReadOnly]),
    },
    {
      strategy: findEmojiEntities,
      component: partial(EmojiDecorator, [isPdf || isReadOnly]),
    },
    {
      strategy: findCustomClassEntities,
      component: CustomClassDecorator,
    },
  ]);
};

export const getInitialState = (props: t.InnerProps): EditorState => {
  const { data, isReadOnly } = props;
  const decorator = getDecorator(isReadOnly);

  try {
    if (!data) {
      return EditorState.createEmpty(decorator);
    }

    if (typeof data === 'string') {
      return EditorState.createWithContent(ContentState.createFromText(data), decorator);
    }

    if (data.raw) {
      const editorState = EditorState.createWithContent(convertFromRaw(data.raw), decorator);
      const plainText = editorState.getCurrentContent().getPlainText();

      // This condition is needed for the situation when raw can create content equal to an empty string
      if (plainText) {
        return editorState;
      }
    }

    if (data.text) {
      return EditorState.createWithContent(ContentState.createFromText(data.text), decorator);
    }

    return EditorState.createEmpty(decorator);
  } catch (e) {
    console.error(e);
    return EditorState.createEmpty(decorator);
  }
};

export const getBlockMapFromText = (text: string) => {
  const blocksFromHTML = text.split('\n').map((text) => new ContentBlock({ key: genKey(), text }));
  return ContentState.createFromBlockArray(blocksFromHTML).getBlockMap();
};

export const getTextLengthOfSelectedBlocks = (editorState: Draft.EditorState) => {
  // length of plain text + length of new line characters
  return getSelectionText(editorState).length + getSelectedBlocksList(editorState).size - 1;
};
